import { Room } from "src/app/models/Chat.v2";
import db from "src/db";

/**
 * Fetches all rooms for a given collaboration
 * @param collabId - The collaboration ID
 * @returns Promise<Room[]> - Array of rooms
 */
export const fetchRooms = async (collabId: string): Promise<Room[]> => {
  if (!collabId) return [];

  try {
    const snap = await db
      .collection("collaborations")
      .doc(collabId)
      .collection("rooms")
      .get();

    return snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as Room[];
  } catch (error) {
    console.error(
      `[fetchRooms] Error fetching rooms for collabId: ${collabId}`,
      error
    );
    return [];
  }
};
